import { render } from "./HelloWorld.vue?vue&type=template&id=469af010&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=469af010&scoped=true&lang=css"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469af010"],['__file',"src/components/HelloWorld.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "469af010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('469af010', __exports__)) {
    console.log('reload')
    api.reload('469af010', __exports__)
  }
  
  module.hot.accept("./HelloWorld.vue?vue&type=template&id=469af010&scoped=true", () => {
    console.log('re-render')
    api.rerender('469af010', render)
  })

}


export default __exports__